import React from 'react';
import { SEO } from '../components/SEO';
export function ImpressumPage() {
  return <>
      <SEO title="Impressum - CRM Kraft | Justus Kraft" description="Impressum und Kontaktinformationen für CRM Kraft - Justus Kraft." keywords="impressum, CRM Kraft, Justus Kraft, Kontakt" ogType="website" data-id="element-435" />
      <main className="pt-32 pb-20 px-4 sm:px-6 lg:px-8" data-id="element-436">
        <div className="max-w-4xl mx-auto" data-id="element-437">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-white" data-id="element-438">
            Impressum
          </h1>

          <div className="prose prose-invert prose-lg max-w-none" data-id="element-439">
            <section className="mb-8" data-id="element-440">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-441">
                Adresse
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-442">
                CRM Kraft LLC
                <br data-id="element-443" />
                Vertreten durch: Justus Kraft
                <br data-id="element-444" />
                7901 4th St. N, Ste. 300
                <br data-id="element-445" />
                St. Petersburg, FL 33702
                <br data-id="element-446" />
                United States of America
              </p>
            </section>

            <section className="mb-8" data-id="element-447">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-448">
                Kontakt
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-449">
                Telefon: +49 157 35999071
                <br data-id="element-450" />
                E-Mail: justus@crm-kraft.de
              </p>
            </section>

            <section className="mb-8" data-id="element-451">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-452">
                EU-Streitschlichtung
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-453">
                Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:{' '}
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#3B82F6] hover:text-[#60A5FA] transition-colors" data-id="element-454">
                  https://ec.europa.eu/consumers/odr/
                </a>
                . Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
            </section>

            <section className="mb-8" data-id="element-455">
              <h2 className="text-2xl font-semibold mb-4 text-white" data-id="element-456">
                Verbraucherstreitbeilegung/Universalschlichtungsstelle
              </h2>
              <p className="text-[#94A3B8] leading-relaxed" data-id="element-457">
                Wir sind nicht bereit oder verpflichtet, an
                Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>
          </div>
        </div>
      </main>
    </>;
}